import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from '../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { view04ImageOptions } from './views/View04'

class X43BathingPlatform extends Component {
    constructor(props) {
        super(props);
        this.handleBathingPlatformChange = this.handleBathingPlatformChange.bind(this);
    }

    handleBathingPlatformChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BathingPlatform = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = view04ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.141686, 0.047882, 0, -0.000039,
                    0.06805, 0.311875, 0, 0.000174,
                    0, 0, 1, 0,
                    290, 93, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_3" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans defaults='The X4<sup>3</sup> features an optional bathing platform which is operated electrically, integrated attachment for “hang on” bathing ladder with {{wood}} steps.' values={{ wood: (this.props.configuration.Deck.value === 1) ? ' teak' : 'flexiteek'}} /></p>

                    <RadioGroup label={this.props.t("Bathing platform:")} options={this.props.bathingPlatformOptions} value={this.props.configuration.BathingPlatform} onChange={this.handleBathingPlatformChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X43BathingPlatform);


// WEBPACK FOOTER //
// ./src/X43/X43BathingPlatform.js